import { AuthClientPlugin, AuthPluginOptions } from "@blitzjs/auth"
import { setupBlitzClient } from "@blitzjs/next"
import { BlitzRpcPlugin } from "@blitzjs/rpc"

export const authConfig: Partial<Omit<AuthPluginOptions, "cookiePrefix">> &
  Required<Pick<AuthPluginOptions, "cookiePrefix">> = {
  cookiePrefix: "paywall",
  // Disabling which will break the current implementation of superwall for web.
  // We'll have to revisit it at some point
  // sameSite: "none",
  secureCookies: true,
}

export const { withBlitz } = setupBlitzClient({
  plugins: [AuthClientPlugin(authConfig), BlitzRpcPlugin({})],
})
